import { SET_ORGANIZATION_LIST, SET_ORGANIZATION_VIEWS_LIST } from '../types/organization'
import { getOrganizationsAPI, getOrganizationViewsAPI } from '../api/organization'
import { addMessageCurry } from '../utils/api'

export const saveOrganizations = (payload) => ({
  type: SET_ORGANIZATION_LIST,
  payload: payload,
})
export const saveOrganizationViews = (payload) => ({
  type: SET_ORGANIZATION_VIEWS_LIST,
  payload: payload,
})

export const getOrganizations = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getOrganizationsAPI(), dispatch).then((organizations) => {
        dispatch(saveOrganizations({ organizations }))
        resolve(organizations)
      })
    })
  }
}

export const getOrganizationViews = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getOrganizationViewsAPI(), dispatch).then((organizationViews) => {
        dispatch(saveOrganizationViews({ organizationViews }))
        resolve(organizationViews)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/organization.js